import axiosInstance from '../../../shared/api/AxiosInstance';

export function createVisitorPublic(payload) {
    return axiosInstance.post('/public/visitors', payload);
}

export function listVisitors(params) {
    return axiosInstance.get('/public/visitors', { params });
}

export function leaveVisitorPublic(payload) {
    return axiosInstance.post('/public/visitors/leave', payload);
}

export function leaveEventForCurrentUser(eventId) {
    return axiosInstance.post('/visitors/leave-event', { eventId }).catch(async (error) => {
        const status = error?.response?.status;
        if (status !== 404) throw error;
        try {
            const stored = localStorage.getItem('userDetails');
            const parsed = stored ? JSON.parse(stored) : null;
            const email = parsed?.user?.email;
            const phone = parsed?.user?.phoneNumber;
            return await axiosInstance.post('/public/visitors/leave', { eventId, email, phone });
        } catch {
            throw error;
        }
    });
}
